/* Progressive enhancement: all three scenes remain readable without JavaScript. */
(() => {
  'use strict';
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const setup=(scope=document)=>{
    scope.querySelectorAll('[data-pilates-edit]').forEach(edit=>{
      if(edit.dataset.pilatesReady)return;
      const tabs=[...edit.querySelectorAll('[data-pilates-tab]')];
      const panels=[...edit.querySelectorAll('[data-pilates-scene]')];
      if(tabs.length!==3||panels.length!==3)return;
      const nav=edit.querySelector('.pilates-edit-tabs');
      nav.setAttribute('role','tablist');
      let current=0,animation;
      tabs.forEach((tab,index)=>{
        tab.setAttribute('role','tab');
        tab.setAttribute('aria-controls',panels[index].id);
        tab.removeAttribute('aria-current');
        panels[index].setAttribute('role','tabpanel');
      });
      const select=(index,focus=false,animate=true)=>{
        animation?.cancel();
        tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});
        const panel=panels[index];
        if(focus)tabs[index].focus({preventScroll:true});
        if(animate&&index!==current&&!reduce.matches&&panel.animate){
          animation=panel.animate([{opacity:.4,transform:'translateY(7px)'},{opacity:1,transform:'none'}],{duration:300,easing:'cubic-bezier(.22,1,.36,1)'});
          animation.finished.catch(()=>{});
        }
        current=index;
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',event=>{event.preventDefault();select(index)});
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=(index+1)%tabs.length;
          if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=tabs.length-1;
          if(next!==undefined){event.preventDefault();select(next,true)}
        });
      });
      edit.dataset.pilatesReady='true';
      select(0,false,false);
    });
  };
  setup();
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
